import { Alert, AlertDescription } from '~/components/ui/alert'

/** Erreur d'un formulaire, sous ses champs ; rien sans message. */
export const FormErrorAlert = ({ message }: { message: string | null }) =>
  message ? (
    <Alert variant="destructive">
      <AlertDescription className="text-destructive">{message}</AlertDescription>
    </Alert>
  ) : null
